import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import * as moment from 'moment';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { ProformaService } from 'src/app/api/sale/proforma.service';
import { ToolsService } from 'src/app/utils/tools.service';
declare var $: any;

@Component({
  selector: 'app-proforma-list',
  templateUrl: './proforma-list.component.html',
  styleUrls: ['./proforma-list.component.css']
})
export class ProformaListComponent implements OnInit {
  private thisComponent: ProformaListComponent;

  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables
  transaction_cash: any = 1;
  transaction_credit: any = 2;
  start_range: any = moment().startOf('month');
  end_range: any = moment().endOf('month');

  constructor(
    private routeActivated: ActivatedRoute,
    private proformaService: ProformaService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.generateCalendar();
    this.list();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
  }

  generateCalendar() {
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        startDate: component_.start_range,
        endDate: component_.end_range,
        showDropdowns: true
      },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
        component_.list();
      }
    );
  }

  list() {
    let val_params =
      'search=' +
      this.params.search +
      '&page=' +
      this.page +
      '&start_range=' +
      this.start_range.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range.format('YYYY-MM-DD');
    this.proformaService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;

        console.log(this.items);
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.start_range = moment().startOf('month');
    this.end_range = moment().endOf('month');
    this.generateCalendar();
    this.list();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/ventas/proformas/editar',
      id
    ]);
  }

  detail(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/ventas/proformas/detalle',
      id
    ]);
  }

  delete(item: any, _index: any) {
    let options = {
      title: '¿Estás segur@?',
      message: "La proforma N°"+item.description+" será eliminado",
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.proformaService.delete(item.id).subscribe({
          next: (data: any) => {
            this.items.splice(_index, 1);
            this.alertifyMsg.success(
              'El registro ' + item.description + ' se ha eliminado con éxito'
            );
            this.list();
          }
        });
      }
    });
  }
}
